<template>
  <div class="min-h-screen flex flex-col">
    <!-- 顶部通知栏 -->
    <div v-if="showNotification" class="bg-gradient-to-r from-primary-600 to-accent-600 text-white">
      <div class="container-custom">
        <div class="flex items-center justify-between py-2">
          <div class="flex items-center space-x-2">
            <span class="text-sm font-medium">🎉 限时优惠：新用户首月免费试用！</span>
          </div>
          <button @click="closeNotification" class="p-1 hover:bg-white/20 rounded-full transition-colors"
            aria-label="关闭通知">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- 头部导航 -->
    <Header />

    <!-- 主要内容 -->
    <main class="flex-grow">
      <slot />
    </main>

    <!-- 页脚 -->
    <Footer />

    <!-- 侧边悬浮按钮（移动端） -->
    <div class="fixed bottom-24 right-4 z-40 lg:hidden">
      <div class="flex flex-col space-y-3">
        <!-- 联系按钮 -->
        <button @click="openContactModal"
          class="w-14 h-14 bg-gradient-primary rounded-full shadow-lg flex items-center justify-center text-white hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
          aria-label="联系客服">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
        </button>

        <!-- 咨询按钮 -->
        <button @click="openConsultation"
          class="w-14 h-14 bg-gradient-accent rounded-full shadow-lg flex items-center justify-center text-white hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
          aria-label="在线咨询">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import Header from '@/components/layout/Header.vue'
  import Footer from '@/components/layout/Footer.vue'

  export default {
    name: 'DefaultLayout',
    components: {
      Header,
      Footer
    },
    data() {
      return {
        showNotification: true
      }
    },
    methods: {
      closeNotification() {
        this.showNotification = false
        localStorage.setItem('notification_closed', 'true')
      },
      openContactModal() {
        this.$router.push('/contact')
      },
      openConsultation() {
        // 这里可以打开聊天窗口或跳转到咨询页面
        window.open('https://chat.example.com', '_blank')
      }
    },
    mounted() {
      // 检查是否已经关闭过通知
      const notificationClosed = localStorage.getItem('notification_closed')
      if (notificationClosed === 'true') {
        this.showNotification = false
      }

      // 监听滚动事件
      window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style scoped>
  .page-transition-enter-active {
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  .page-transition-enter {
    opacity: 0;
    transform: translateY(20px);
  }
</style>